//import SettingsPanel from 'components/settings-panel/SettingsPanel';
//import SettingsToggle from 'components/settings-panel/SettingsToggle';
import useToggleStyle from 'hooks/useToggleStyle';
import { useAppContext } from 'providers/AppProvider';
import { useSettingsPanelContext } from 'pages/template/providers/SettingsPanelProvider';
import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';


// TODO impostare questo header 'X-Frame-Options' a 'deny' (importante)


/*
import { useAuth } from 'providers/AuthProvider'
function AuthStatus() {
  const auth = useAuth();
  const navigate = useNavigate();

  if (!auth.user) {
    return <p>You are not logged in.</p>;
  }

  return (
    <p>
      Welcome {auth.user.username}!{" "}
      <button
        onClick={() => {
          auth.signout(() => navigate("/"));
        }}
      >
        Sign out
      </button>
    </p>
  );
}

*/

const App = () => {
  const { isStylesheetLoaded } = useToggleStyle();
  const { pathname } = useLocation();

  const {
    settingsPanelConfig: { showSettingPanelButton },
    setSettingsPanelConfig
  } = useSettingsPanelContext();

  const {
    config: { theme, isRTL }
  } = useAppContext();

  // Automatically scrolls to top whenever pathname changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    setSettingsPanelConfig({
      openSettingPanel: false
    });
  }, [isRTL]);

  return (
    <>
      {!isStylesheetLoaded ? (
        <div
          style={{
            position: 'fixed',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: theme === 'dark' ? '#000' : '#fff'
          }}
        />
      ) : (
        <>
          {/*<AuthStatus /> */}

          {/* Outlet is used to tell where we want to render child routes
          An <Outlet> should be used in parent route elements to render their child route elements. 
          This allows nested UI to show up when child routes are rendered. If the parent route matched exactly, 
          it will render a child index route or nothing if there is no index route.        
        */}
          <Outlet />

          {/*showSettingPanelButton && (
            <>
              <SettingsToggle />
              <SettingsPanel />
            </>
          )*/}
        </>
      )}
    </>
  );
};

export default App;
